import React from 'react';
import styled from 'styled-components';

const BodyStyle = styled.div`
	display: flex;

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const ActivationModalBody = ({ text }) => {
	return (
		<BodyStyle>
			<div className='body10'>{text}</div>
		</BodyStyle>
	);
};
